export const BlogPageMetaData = {
  title: 'Unit Conversion Page| Blog',
  description: '',
  image: '%PUBLIC_URL%/android-icon-192x192.png',
  url: 'https://unitconversion.page/blog',
  type: 'website',
}
